"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

Object.defineProperty(exports, "__esModule", { value: true });
var parseCookies = function parseCookies(s) {
    if (s.length === 0) return {};
    var parsed = {};
    var pattern = new RegExp('\\s*;\\s*');
    s.split(pattern).forEach(function (i) {
        var _i$split = i.split('='),
            _i$split2 = _slicedToArray(_i$split, 2),
            encodedKey = _i$split2[0],
            encodedValue = _i$split2[1];

        var key = decodeURIComponent(encodedKey);
        var value = decodeURIComponent(encodedValue);
        parsed[key] = value;
    });
    return parsed;
};
exports.parseCookies = parseCookies;